<template>
  <div>
    <el-tooltip :content="value" placement="top">
      <el-switch
        v-model="value"
        active-color="#13ce66"
        inactive-color="#ff4949"
        :active-value="enable"
        :inactive-value="disabled"
        @change="
          (event) =>
            changeStatus(
              $attrs.row ?? this.row,
              $attrs.column ?? this.col,
              event
            )
        "
      >
      </el-switch>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "SwitchButton",
  props: {
    Call: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      value: "",
      disabled: "INACTIVO",
      enable: "ACTIVO",
      URi: "",
      row: this.$attrs.row ?? this.$attrs.row,
      col: this.$attrs.column ?? this.$attrs.col.property
    };
  },
  methods: {
    async changeStatus(val, col, event) {
      // decision para activar o desactivar contacto al portal de clientes.
      if (col === "ContactCode") {
        this.CallPortal(val);
      } else if (col === "CXC_Notifications" || col === "SC_Notifications") {
        await this.callCXCSCnotifications(val, col, event);
      }
      // else if (col === "SC_Notifications") {
      //   this.callSCnotifications(val);
      // }
    },
    HasPortal(val) {
      // valida que correo registrado en el portal
      if (val.HasPortal == true) {
        this.value = this.enable;
      } else {
        this.value = this.disabled;
      }
    },
    CallPortal(val) {
      if (this.value === this.enable) {
        // dialogo confirm para estar seguro que el usuario quiere activar el contacto
        this.$confirm(
          "Seguro que desea registrar este contacto en el Portal Web",
          "Cuidado!",
          {
            type: "warning",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar"
          }
        )
          .then((response) => {
            if (response === "confirm") {
              // si el usuario confirma activar el contacto, se abre una nueva ventana con la url del portal para registrar en contacto
              // me aseguro que sea por compañía
              let link = document.createElement("a");
              switch (val.CompanyId) {
                case "MTR":
                  this.URi =
                    "https://portal.magytrack.net/Account/Register?cc=" +
                    val.CustomerCode +
                    "&el=" +
                    val.Email +
                    "&ci=" +
                    val.CompanyId;

                  link.href = this.URi;
                  link.target = "_blank";
                  link.click();
                  break;
                case "TB":
                  this.URi =
                    "https://portal.tennosbusiness.net/Account/Register?cc=" +
                    val.CustomerCode +
                    "&el=" +
                    val.Email +
                    "&ci=" +
                    val.CompanyId;

                  link.href = this.URi;
                  link.target = "_blank";
                  link.click();
                  break;
              }
            }
          })
          .catch((response) => {
            if (response === "cancel") {
              this.$message({
                typ: "info",
                message: "Acción cancelada"
              });
              this.value = this.disabled;
            }
          });
      } else {
        // bloque para desactivar usuario del portal
        this.$confirm(
          "Seguro que desea bloquear el acceso este contacto en el Portal Web",
          "Cuidado!",
          {
            type: "warning",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar"
          }
        ).catch((response) => {
          if (response === "cancel") {
            this.$message({
              typ: "info",
              message: "Acción cancelada"
            });
            this.value = this.enable;
          }
        });
      }
    },
    async callCXCSCnotifications(val, col, event) {
      // this.Call(val);
      let params = {
        Id: val.iduser,
        UserId: val.Id_Usuario,
        Nombre: val.FullName,
        Email: val.Email,
        Status: val.status,
        Codigo_Empresa: val.CustomerCode,
        Contact_code: val.ContactCode,
        CXC: val.CXC,
        ServicioAlCliente: val.SERVICIOALCLIENTE,
        TipoNotification: val.TipoNotification
      };

      if (col === "CXC_Notifications") {
        if (event === "ACTIVO") {
          params.CXC = true;
        } else if (event === "INACTIVO") {
          params.CXC = false;
        }
        // params.CXC = event === "ACTIVO" ? true : false;
      } else if (col === "SC_Notifications") {
        if (event === "ACTIVO") {
          params.SERVICIOALCLIENTE = true;
        } else if (event === "INACTIVO") {
          params.SERVICIOALCLIENTE = false;
        }
        // params.SERVICIOALCLIENTE = event === "ACTIVO" ? true : false;
      }

      this.loading = true;
      await this.$http
        .put("/api/contacts/setCXCSC_NotificationStatus", params)
        .catch((error) => {
          console.error(error);
        })
        .then(({ data }) => {
          this.Call();
          this.$message.success("Contacto agregado para notificar", data);
        })
        .finally(() => {
          this.loading = false;
          // this.getItems();
        });
    }
    // callSCnotifications(val){

    // }
  },
  // created() {

  //   if(this.col === "CXC_Notifications"){

  //       this.value = this.row.CXC

  //   }
  //   else if(this.col === "SC_Notifications"){

  //       this.value = this.row.SERVICIOALCLIENTE

  //   }
  // },
  mounted() {
    this.HasPortal(this.$attrs.row);

    if (this.col === "CXC_Notifications") {
      this.value = this.row.CXC ? this.enable : this.disabled;
    } else if (this.col === "SC_Notifications") {
      this.value = this.row.SERVICIOALCLIENTE ? this.enable : this.disabled;
    }
  }
};
</script>
